import actionTypes from './../constants/actionTypes';

const initialState = {
    listing: {},
    configuration: {},
    saveConfigurationRespnose: {},
    zerodhaSaveConfigResponse: {},
};
export const stockReducer = (state = initialState, action) => {
    try {
        const { type, payload, status } = action;
        switch (type) {
            case actionTypes.CONFIGURATION.CONFIGURATION_LIST: {
                return {
                    ...state,
                    listing: {
                        ...state.listing,
                        ...payload
                    }
                }
            }
            case actionTypes.CONFIGURATION.GET_CONFIGURATION_SUCCESS: {
                return {
                    ...state,
                    configuration: payload
                }
            }
            case actionTypes.CONFIGURATION.SAVE_CONFIGURATION_SUCCESS: {
                return {
                    ...state,
                    saveConfigurationRespnose: payload
                }
            }
            case actionTypes.CONFIGURATION.ZERODHA_LOGIN_CONFIG: {
                return {
                    ...state,
                    zerodhaConfig: payload
                }
            }
            case actionTypes.CONFIGURATION.ZERODHA_SAVE_CONFIG: {
                return {
                    ...state,
                    zerodhaSaveConfigResponse: payload
                }
            }
        }
        return state;
    } catch (error) {
        return state;
    }
}
export default stockReducer;
